import React from "react";
import ReactDOM from "react-dom";
import App from "./App";
import * as serviceWorker from "./serviceWorker";

const $elements = Array.from(
    document.getElementsByClassName("prh-wishlist-side-panel-app-root")
);
if ($elements.length > 0) {
    $elements.forEach(function ($el) {
        ReactDOM.render(<App />, $el);
    });
}

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();



// WEBPACK FOOTER //
// ./src/index.js